import request from './request.js';

/**
 *
 * @param {*} cursor
 * @param {*} filters
 */
function getAll(cursor, filters) {
    let endpoint = `/claims?cursor=${ cursor }`;

    if (filters.query) {
        const encodedQuery = encodeURIComponent(filters.query);
        endpoint += `&query=${ encodedQuery }`;
    }

    if (filters.category) {
        endpoint += `&category=${ filters.category }`;
    }

    if (filters.benefit) {
        endpoint += `&benefit=${ filters.benefit }`;
    }

    if (filters.status) {
        endpoint += `&status=${ filters.status }`;
    }

    if (filters.type) {
        endpoint += `&type=${ filters.type }`;
    }

    if (filters.sortBy) {
        endpoint += `&sortBy=${ filters.sortBy }`;
    }

    if (filters.sortDirection) {
        endpoint += `&sortDirection=${ filters.sortDirection }`;
    }

    if (filters.assignedTo !== undefined) {
        endpoint += `&assignedTo=${ filters.assignedTo }`;
    }

    const options = {
        endpoint,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param cursor
 * @param filters
 * @returns {Promise<unknown>}
 */
function getPredeterminations(cursor, filters) {
    let endpoint = `/predeterminations?cursor=${ cursor }`;

    if (filters.query) {
        const encodedQuery = encodeURIComponent(filters.query);
        endpoint += `&query=${ encodedQuery }`;
    }

    if (filters.benefit) {
        endpoint += `&benefit=${ filters.benefit }`;
    }

    const options = {
        endpoint,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param predeterminationID
 * @returns {Promise<unknown>}
 */
function downloadPredetermination(predeterminationID) {
    const options = {
        endpoint: `/predeterminations/${ predeterminationID }/summary`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param predeterminationID
 * @returns {Promise<unknown>}
 */
function removePredetermination(predeterminationID) {
    const options = {
        endpoint: `/predeterminations/${ predeterminationID }`,
        method: 'DELETE'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} claimID
 */
function getSingle(claimID) {
    const options = {
        endpoint: `/claims/${ claimID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @param body
 */
function declineClaimSingleItem(claimID, body) {
    const options = {
        endpoint: `/claims/${ claimID }/adjudicate/reject/singleItem`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @param body
 * @returns {Promise<unknown>}
 */
function referClaimSingleItem(claimID, body) {
    const options = {
        endpoint: `/claims/${ claimID }/adjudicate/refer/singleItem`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @param body
 */
function approveClaimSingleItem(claimID, body) {
    const options = {
        endpoint: `/claims/${ claimID }/adjudicate/approve/singleItem`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @param body
 */
function submitMultiItemClaim(claimID, body) {
    const options = {
        endpoint: `/claims/${ claimID }/adjudicate/multiItem`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @returns {Promise<unknown>}
 */
function stopPayment(claimID) {
    const options = {
        endpoint: `/claims/${ claimID }/stopPayment`,
        method: 'POST',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @returns {Promise<unknown>}
 */
function resetAdjudication(claimID) {
    const options = {
        endpoint: `/claims/${ claimID }/reset`,
        method: 'POST',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param body
 * @returns {Promise<unknown>}
 */
function submitClaim(userID, body) {
    const options = {
        endpoint: `/claims/${ userID }`,
        method: 'POST',
        noJson: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param body
 */
function submitDentalEDIClaim(userID, body) {
    const options = {
        endpoint: `/claims/dentalEDI/claim/${ userID }`,
        method: 'POST',
        noJson: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param body
 */
function submitDentalEDICOB(userID, body) {
    const options = {
        endpoint: `/claims/dentalEDI/cob/${ userID }`,
        method: 'POST',
        noJson: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param body
 */
function submitDentalEDIPredetermination(userID, body) {
    const options = {
        endpoint: `/claims/dentalEDI/predetermination/${ userID }`,
        method: 'POST',
        noJson: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @param status
 * @returns {Promise<unknown>}
 */
function changeClaimStatus(claimID, status) {
    const options = {
        endpoint: `/claims/${ claimID }/status/${ status }`,
        method: 'PUT',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @param assignedTo
 * @returns {Promise<unknown>}
 */
function reassignClaim(claimID, assignedTo) {
    const options = {
        endpoint: `/claims/${ claimID }/reassign/${ assignedTo }`,
        method: 'PUT',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @param assignedTo
 * @returns {Promise<unknown>}
 */
function reassignPendingManual(ediClaimID, assignedTo) {
    const options = {
        endpoint: `/claims/dentalEDI/pendingManual/${ ediClaimID }/reassign/${ assignedTo }`,
        method: 'PUT',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<unknown>}
 */
function getAgentBenefitAssignments() {
    const options = {
        endpoint: `/claims/agent/assignments`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param masterID
 * @param benefits
 * @returns {Promise<unknown>}
 */
function saveAgentBenefitAssignments(masterID, benefits) {
    const options = {
        endpoint: `/claims/assign/adjudicatorBenefits/${ masterID }`,
        method: 'POST',
        body: {
            benefits
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param dentist
 * @param officePostalCode
 * @returns {Promise<unknown>}
 */
function validateDentistForEDI(dentist, officePostalCode) {
    const options = {
        endpoint: `/claims/dentalEDI/validateDentistForEDI`,
        method: 'POST',
        body: {
            dentist,
            officePostalCode
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * Get the details for the claim reversal
 * @param claimID
 */
function dentalReversalCheck(claimID) {
    const options = {
        endpoint: `/claims/dentalEDI/claim/${ claimID }/reversal/status`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * Reverse the dental claim
 * @param claimID
 */
function reverseDentalClaim(claimID) {
    const options = {
        endpoint: `/claims/dentalEDI/claim/${ claimID }/reversal`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<unknown>}
 */
function getPendingManualTransactions(type, query) {
    const options = {
        endpoint: `/claims/dentalEDI/pendingManual`,
        method: 'POST',
        body: {
            type: type || null,
            query: query || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param uid
 */
function setNeedsMoreInformation(uid) {
    const options = {
        endpoint: `/claims/dentalEDI/pendingManual/needsMoreInformation/${ uid }`,
        method: 'PUT'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param uid
 * @returns {Promise<unknown>}
 */
function removePendingManualDentalClaim(uid) {
    const options = {
        endpoint: `/claims/dentalEDI/pendingManual/${ uid }`,
        method: 'DELETE'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<unknown>}
 */
function getPendingManualTransaction(uid) {
    const options = {
        endpoint: `/claims/dentalEDI/pendingManual/${ uid }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}


/**
 * 
 * @returns {Promise<unknown>}
 */
function getDentalCodes(cursor, query, yearFilter, codeTypeFilter) {
    const params = new URLSearchParams();

    params.append('query', query || '');
    params.append('cursor', cursor || 0);
    params.append('yearFilter', yearFilter || 'All');
    params.append('codeTypeFilter', codeTypeFilter || 'All');

    const queryString = `?${ params.toString() }`;

    const options = {
        endpoint: `/claims/dentalEDI/dentalCodes${ queryString }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @returns {Promise<unknown>}
 */
function getDentalPayees(cursor, query) {
    const queryString = `?query=${ encodeURIComponent(query || "") }&cursor=${ encodeURIComponent(cursor || 0) }`;
    const options = {
        endpoint: `/claims/dentalEDI/dentalPayees${ queryString }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @param timeSpent
 * @returns {Promise<unknown>}
 */
function updateAdjudicationTime(claimID, timeSpent) {
    const options = {
        endpoint: `/claims/${ claimID }/adjudicationTime`,
        method: 'PUT',
        body: {
            timeSpent
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param body - FormData containing cert, patient, and docs
 */
function processWithDentalAI(body) {
    const options = {
        endpoint: `/claims/dental/ai`,
        method: 'POST',
        noJson: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param type
 * @param query
 * @param status
 * @param sortBy
 * @param sortDirection
 * @param limit
 * @param offset
 * @returns {Promise<unknown>}
 */
function getInstreamNotifications(type, query, status, sortBy, sortDirection, limit, offset) {
    const params = new URLSearchParams();

    params.append('query', query || '');
    params.append('status', status || 'All');
    params.append('sortBy', sortBy || 'Certificate Number');
    params.append('sortDirection', sortDirection || 'DESC');
    params.append('limit', limit || 50);
    params.append('offset', offset || 0);

    const options = {
        method: 'GET',
        endpoint: `/providers/instream/notifications/${ type }?${ params.toString() }`
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param type
 * @param batchID
 * @returns {Promise<Blob>}
 */
function downloadInstreamNotificationFile(type, batchID) {
    const options = {
        method: 'GET',
        endpoint: `/providers/instream/notifications/${ type }/download/${ batchID }`,
        responseType: 'blob'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    getAll,
    getSingle,
    approveClaimSingleItem,
    declineClaimSingleItem,
    submitMultiItemClaim,
    referClaimSingleItem,
    stopPayment,
    resetAdjudication,
    submitClaim,
    submitDentalEDIClaim,
    submitDentalEDICOB,
    submitDentalEDIPredetermination,
    changeClaimStatus,
    reassignClaim,
    getAgentBenefitAssignments,
    saveAgentBenefitAssignments,
    validateDentistForEDI,
    getPredeterminations,
    downloadPredetermination,
    getPendingManualTransactions,
    getPendingManualTransaction,
    reverseDentalClaim,
    dentalReversalCheck,
    removePredetermination,
    setNeedsMoreInformation,
    removePendingManualDentalClaim,
    reassignPendingManual,
    getDentalCodes,
    getDentalPayees,
    updateAdjudicationTime,
    processWithDentalAI,
    getInstreamNotifications,
    downloadInstreamNotificationFile
};